import React, { useState, useEffect, useRef } from "react";

import SvgImage from "../../Icons/Icons";
import { useSelector } from "react-redux";
import moment from "moment";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";

const Info = (props) => {
  //   const [path, setPath] = useState([[props.latt, props.longg]]);
  const { gpsComputedVehicleData, gpsComputedVehicleDataLoader } = useSelector(
    (state) => state?.fleet
  );
  let running = 0,
    timeString = "",
    stop = 0,
    timeStop = "";
  console.log("sjjfeiprj", gpsComputedVehicleData);
  if (gpsComputedVehicleData?.length == 10) {
    let exTime = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
    gpsComputedVehicleData.map((d) => {
      if (d?.status == "RUNNING") {
        if (
          d?.fromTime &&
          moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss") >= moment(exTime)
        ) {
          let from = d?.fromTime
            ? moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss")
            : moment(new Date());
          let to = d?.toTime
            ? moment(d?.toTime, "YYYY-MM-DD HH:mm:ss")
            : moment(new Date());
          let dif = to.diff(from);
          running = running + dif;
          console.log("running1", running);
        } else if (
          d?.fromTime &&
          d?.toTime &&
          moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss") < moment(exTime) &&
          moment(d?.toTime, "YYYY-MM-DD HH:mm:ss") > moment(exTime)
        ) {
          let from = moment(exTime);
          let to = d?.toTime
            ? moment(d?.toTime, "YYYY-MM-DD HH:mm:ss")
            : moment(new Date());
          let dif = to.diff(from);
          running = running + dif;
          console.log("running2", running);
        }
      }
      if (d?.status == "STOPED" || d?.status == "STOPPED") {
        if (
          d?.fromTime &&
          moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss") >= moment(exTime)
        ) {
          let from = d?.fromTime
            ? moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss")
            : moment(new Date());
          let to = d?.toTime
            ? moment(d?.toTime, "YYYY-MM-DD HH:mm:ss")
            : moment(new Date());
          let dif = to.diff(from);
          stop = stop + dif;
          console.log("stop1", stop);
        } else if (
          d?.fromTime &&
          d?.toTime &&
          moment(d?.fromTime, "YYYY-MM-DD HH:mm:ss") < moment(exTime) &&
          moment(d?.toTime, "YYYY-MM-DD HH:mm:ss") > moment(exTime)
        ) {
          let from = moment(exTime);
          let to = d?.toTime
            ? moment(d?.toTime, "YYYY-MM-DD HH:mm:ss")
            : moment(new Date());
          let dif = to.diff(from);
          stop = stop + dif;
          console.log("stop2", stop);
        }
      }
    });
    running = running / 1000;
    var hours = Math.floor(running / 3600);
    var minutes = Math.floor((running - hours * 3600) / 60);

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    timeString = hours + "h " + minutes + "m";
    stop = stop / 1000;
    hours = Math.floor(stop / 3600);
    minutes = Math.floor((stop - hours * 3600) / 60);

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    timeStop = hours + "h " + minutes + "m";
  }

  return (
    <>
      {gpsComputedVehicleDataLoader ? (
        <Stack
          sx={{ width: "100%", color: "grey.500", margin: "30px 0 0 0 " }}
          spacing={2}
        >
          <LinearProgress color="secondary" />
          <LinearProgress color="success" />
          <LinearProgress color="inherit" />
        </Stack>
      ) : (
        <div className="row cardInfo4 FontNS16" style={{margin: "15px 0 0 0"}}>
          <div className="col-12">Recent Activity : </div>
          <div className="col-12 row">
            <div className="col-5">Running Time</div>
            <div className="col-7" style={{color : "green"}}>{timeString}</div>
          </div>
          <div className="col-12 row">
            <div className="col-5">Stopping Time</div>
            <div className="col-7"  style={{color : "red"}}>{timeStop}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default Info;
